/**
 * JavaScript fuer das Hauptmenue
 */

const classic = function() {

    $('#navigation').sortable({
        update: function() {

            var prefix = 'group_';

            var ids = $.map($('.menuGroup[data-menu-group-id]'), function(el) {
                return prefix + $(el).attr('data-menu-group-id');
            });

            $.post('/user_profil_subadmin_ajax.php', {
                action:	'sort',
                order: ids
            });
        }
    });

    $('*[data-menu-group-toggle-activated="true"]').find('.heading')
            .append('<button class="toggle"></button>');

    $('[data-menu-group-displayed="0"]').each(function (idx, el) {

        $(el).find('.heading')
            .find('.toggle')
            .addClass('hidden')
            .parent()
            .nextAll()
            .slideToggle()
            .parents('.menuGroup')
            .toggleClass('collapsed');
    });

    $(document).on('click', '.menuGroup .toggle', function() {
        $(this).toggleClass('hidden').parents('.heading').nextAll()
                .slideToggle().parents('.menuGroup')
                .toggleClass('collapsed');

        var isCollapsed = $(this).parents('.menuGroup').hasClass('collapsed');
        var groupId = $(this).parents('.menuGroup').attr('data-menu-group-id');

        $.post('/user_profil_subadmin_ajax.php', {
            action: 'fold',
            show: isCollapsed ? 0 : 1,
            group: 'group_' + groupId
        });
    });

    /**
     * Suchfelder im Menue: Numerische Eingaben als ID erkennen.
     */
    $('.sidebarSearch').on('submit', function() {

        var field            = $(this).find('.searchField'),
            numericFieldName = 'searchField[' + $(this)
                    .attr('data-numeric-field') + ']';

        if (!isNaN(field.val())) {
            $(this).find('input[name="' + numericFieldName + '"]')
                    .val(field.val());
            field.val('');
        }
    });
};

export default classic;
